import React, { useEffect, useState } from "react";
import FormSelect from "../common/FormSelect";
import { DropDownBold } from "../AdminIcons";
import {
  useGetRolesListQuery,
  useUpdateStaffRoleMutation,
} from "../../services/user/userApi";

const ChangeRoleModal = ({ isOpen, onClose, user, onSuccess }) => {
  const { data, isLoading } = useGetRolesListQuery(undefined, { skip: !isOpen });
  const [updateStaffRole, { isLoading: isUpdating }] = useUpdateStaffRoleMutation();
  const [selectedRoleName, setSelectedRoleName] = useState("");
  const [apiError, setApiError] = useState("");

  const rolesOptions = (data?.data || []).map((role) => ({
    label: role.name,
    value: role.name,
  }));

  const handleClose = () => {
    setSelectedRoleName("");
    setApiError("");
    onClose();
  };

  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [isOpen]);

  useEffect(() => {
    if (isOpen) {
      setSelectedRoleName(user?.accessRole || "");
      setApiError("");
    }
  }, [isOpen, user]);

  const handleUpdate = async () => {
    if (!selectedRoleName || !user?.userEmail) {
      setApiError("Please select a role");
      return;
    }

    try {
      setApiError("");
      await updateStaffRole({
        email: user.userEmail,
        roleName: selectedRoleName,
      }).unwrap();
      await onSuccess?.();
      handleClose();
    } catch (error) {
      setApiError(
        error?.data?.message || "Unable to update role. Please try again.",
      );
    }
  };

  if (!isOpen || !user) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 z-[70] flex items-center justify-center overflow-hidden bg-black/45 p-6 sm:p-10"
      onClick={handleClose}
    >
      <div
        className="max-h-[min(92vh,calc(100dvh-2rem))] w-full max-w-[570px] overflow-y-auto rounded-2xl border border-[#00000014] bg-[#EAE9E9] [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="px-12 pt-8 pb-7">
          <h3 className="text-xl font-medium leading-6 text-black">
            Change Role of User
          </h3>

          <div className="mt-10">
            <label className="mb-1.5 block text-black">Select Role</label>
            <FormSelect
              key={`change-role-${user.id}`}
              id="change-role-select"
              options={rolesOptions}
              defaultValue={user.accessRole || ""}
              placeholder={isLoading ? "Loading..." : "Select Role"}
              controlWrapperClassName="mt-0"
              selectClassName="h-11 rounded-[5px] border border-[#00000014] bg-[#D9D9D961] px-4 text-xl text-black"
              dropdownClassName="left-0 w-full py-2 px-3"
              icon={DropDownBold}
              iconProps={{ color: "#3C3C3C" }}
              onChange={(value) => setSelectedRoleName(value)}
            />
          </div>

          {apiError ? (
            <p className="mt-4 text-sm font-medium text-[#DC2626]">{apiError}</p>
          ) : null}

          <div className="mt-10 flex justify-end gap-5">
            <button
              type="button"
              className="h-8 rounded-lg bg-[#DBDBDB] px-6 text-lg font-medium text-[#686868]"
              onClick={handleClose}
            >
              Cancel
            </button>
            <button
              type="button"
              className="h-8 rounded-lg bg-[#923D8C] px-5 text-lg font-medium text-[#FAFCFE] disabled:cursor-not-allowed disabled:opacity-70"
              onClick={handleUpdate}
              disabled={isUpdating || !selectedRoleName}
            >
              {isUpdating ? "Updating..." : "Update"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangeRoleModal;
